module.exports = __webpack_public_path__ + "static/ArchiveVideo02-78fab38ba8de9be1d752b369a598fe66.mp4";